import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import {
  getLocaleDirectory,
  normalizeLocale,
  supportedLocales,
} from './utils/helpers/constants.helpers';

const getInitialLanguage = () => {
  if (typeof window === 'undefined') {
    return 'en';
  }

  const storedLanguage = window.localStorage.getItem('i18nextLng');

  if (storedLanguage) {
    return normalizeLocale(storedLanguage);
  }

  const browserLanguage =
    window.navigator.languages?.[0] || window.navigator.language || 'en';

  return normalizeLocale(browserLanguage);
};

const initialLanguage = getInitialLanguage();

if (typeof window !== 'undefined') {
  localStorage.setItem('i18nextLng', initialLanguage);
}

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: initialLanguage,
    fallbackLng: 'en',
    supportedLngs: supportedLocales,
    nonExplicitSupportedLngs: false,
    load: 'currentOnly',
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: (languages) => {
        const requestedLanguage = languages?.[0];
        const localeDirectory = getLocaleDirectory(requestedLanguage);

        return `/locales/${localeDirectory}/translation.json`;
      },
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
